import { PrinterConfig, PrinterDuty } from './types';
import { normalizePaperWidth } from './paperWidth';

const normalizePrinterConfig = (printer: Partial<PrinterConfig>): PrinterConfig => {
  return {
    id: printer.id ?? crypto.randomUUID(),
    name: printer.name ?? 'local_printer',
    duties: printer.duties ?? ['cashier'],
    ip: printer.ip ?? '',
    port: printer.port ?? 9100,
    timeout: printer.timeout ?? 2000,
    paperWidth: normalizePaperWidth(printer.paperWidth),
    fontSize: printer.fontSize ?? { header: 14, normal: 10, small: 8 },
    margins: printer.margins ?? { top: 5, bottom: 5, left: 5, right: 5 },
    language: printer.language ?? 'es',
    currency: printer.currency ?? 'USD',
  };
};

/** Normalize cashier template settings used by USB and TCP backends. */
export const createDefaultPrinterConfig = (
  overrides: Partial<PrinterConfig> & { ip?: string; name?: string; duties?: PrinterDuty[] }
): PrinterConfig => {
  return normalizePrinterConfig({
    id: crypto.randomUUID(),
    duties: ['cashier'],
    ...overrides,
  });
};
